/** @flow */
import * as React from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { createGenerateClassName, createMuiTheme, jssPreset, MuiThemeProvider } from '@material-ui/core/styles';
import { MuiThemeProvider as V0MuiThemeProvider } from 'material-ui';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { VersionComponent } from 'common/components/VersionComponent';
import 'common/styles/styles.css';
import i18n from './i18n/i18n';
import theme from './themes';

import App from './layout/App';

import { MUI0Theme, MUITheme } from './themes/MuiTheme';

const muiThemeV0 = getMuiTheme(MUI0Theme, {
  userAgent: window.navigator.userAgent,
});

const muiThemeV1 = createMuiTheme(MUITheme);

const generateClassName = createGenerateClassName();
const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById('jss-insertion-point'),
});

const Root = (): React.Element<any> => (
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <MuiThemeProvider theme={muiThemeV1}>
      <V0MuiThemeProvider muiTheme={muiThemeV0}>
        <ThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <Router>
              <React.Fragment>
                <VersionComponent />
                <App />
              </React.Fragment>
            </Router>
          </I18nextProvider>
        </ThemeProvider>
      </V0MuiThemeProvider>
    </MuiThemeProvider>
  </JssProvider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/statsradio/Root.js